import React, { Component } from 'react'
import { Button } from 'reactstrap'

class SaveButton extends Component {

  state = {
    screen : false
  }

  componentDidMount(){
    this.calcWidth();
    window.addEventListener('resize', ()=>{
      this.calcWidth()
    })  
}

calcWidth = () => {
  let widthClient = document.documentElement.clientWidth;
      if(widthClient < 768){
        this.setState({screen : true})
      }
      else{
        this.setState({screen:false})
      }
}

  render() {
    let {screen} = this.state
    const { children, changed, saving, oSave } = this.props
    return (
      <Button
        style={{"borderRadius":"150px","width":"120px"}}
        className='save-button'
        disabled={!!(!changed || saving)}
        onClick={oSave}
      >
        {children}
      </Button>
    )
  }
}

export default SaveButton


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/ActionBlockComponents/SaveButton.js